import React, { useCallback, useState } from 'react';
import styles from './card.module.scss';
import { LessonInProgress } from '@src/api/graphql-codegen';
import Spinner from '@src/components/spinner/Spinner';
import Tooltip from 'antd/es/tooltip';
import { LordIcon } from '@src/components/lord-icon/lord-icon';
import { IconReset } from '@src/constants';

type Props = {
  lesson: LessonInProgress;
  resetProgress?: (lesson: LessonInProgress) => void;
  openLesson?: (lesson: LessonInProgress) => void;
  loading?: boolean;
};

function Card(props: Props) {
  const { lesson, loading, resetProgress, openLesson } = props;
  const { lessonName, progress, gradeName } = lesson;
  const [isHovered, setIsHovered] = useState(false)

  const handleOpenLesson = useCallback(() => {
    openLesson?.(lesson)
  }, [openLesson, lesson])

  const handleResetLesson = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    resetProgress?.(lesson)
  }, [resetProgress, lesson])

  return (
    <article className={styles.card}>
      <section className={styles.content} onClick={handleOpenLesson} onMouseOver={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
        <div className={styles.title}>{gradeName?.replace(/[[\]\\"]/g, "").replace(/,/g, ", ")}</div>
        <div className={styles.title}>{lessonName}</div>
        <div className={styles.progressBackBar}><div className={styles.progressBar} style={{width: `${progress}%`, backgroundColor: "#62C590" }}></div></div>
        <div className={styles.iconWrapper}>
          <div className={styles.action} onClick={handleResetLesson}>
            {loading ? <Spinner width={20} height={20} /> : 
            <Tooltip
              placement='top'
              title={<div className={styles.tooltip}>Reset Lesson</div>}
              arrowPointAtCenter
              color='#FFFFFF'>
              <LordIcon size={30} src={IconReset} isHover={true} colors={{primary: isHovered ? '#FF656E' : '#E4E4E4', secondary: isHovered ? '#FF656E' : '#E4E4E4'}} target='.card_card__QKbbX'/>
            </Tooltip>}
          </div>
        </div>
      </section>
    </article>
  );
}

export default Card;
